import type { ObjectDirective } from 'vue';

const layouts = new WeakMap<HTMLElement, { height: number; animation?: Animation }>();

// Measure the visible height before Vue patches; animate back to natural layout.
// Keeping the same DOM preserves focus, autofill and captcha state.
export const vMotionLayout: ObjectDirective<HTMLElement> = {
  beforeUpdate(element) {
    const previous = layouts.get(element);
    const height = element.getBoundingClientRect().height;
    previous?.animation?.cancel();
    layouts.set(element, { height });
  },
  updated(element) {
    const state = layouts.get(element);
    if (!state || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const height = element.getBoundingClientRect().height;
    if (Math.abs(height - state.height) < 1) return;
    state.animation = element.animate(
      [{ height: `${state.height}px` }, { height: `${height}px` }],
      { duration: 320, easing: 'cubic-bezier(.22,1,.36,1)' },
    );
  },
  beforeUnmount(element) {
    layouts.get(element)?.animation?.cancel();
    layouts.delete(element);
  },
};
